
import TicketApi from './src/TicketResources'

let apis = {
   TicketApi,
};

export default apis;
